import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";

const CITIES = [
  {
    name: "New York City",
    country: "USA",
    flag: "🇺🇸",
    image: "https://public.readdy.ai/ai/img_res/0b64c457b1dbbfa35ba384ae5d3fe519.jpg",
  },
  {
    name: "Miami, Florida",
    country: "USA",
    flag: "🇺🇸",
    image: "https://readdy.ai/api/search-image?query=Miami%20Florida%20beach%20skyline%20completely%20immersed%20in%20deep%20molten%20gold%20amber%20light%20ocean%20reflecting%20pure%20gold%20bronze%20metallic%20warm%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20bronze%20atmosphere%20stunning&width=1440&height=900&seq=puregold-miami&orientation=landscape",
  },
  {
    name: "Chicago",
    country: "USA",
    flag: "🇺🇸",
    image: "https://readdy.ai/api/search-image?query=Chicago%20skyline%20architecture%20glowing%20entirely%20in%20deep%20rich%20gold%20amber%20bronze%20metallic%20light%20lake%20reflecting%20molten%20gold%20luxury%20cinematic%20dramatic%20all%20gold%20warm%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning%20beautiful&width=1440&height=900&seq=puregold-chicago&orientation=landscape",
  },
  {
    name: "Los Angeles",
    country: "California, USA",
    flag: "🇺🇸",
    image: "https://readdy.ai/api/search-image?query=Los%20Angeles%20California%20city%20skyline%20completely%20bathed%20in%20deep%20molten%20gold%20amber%20bronze%20light%20hills%20glowing%20warm%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20bronze%20atmosphere%20stunning%20beautiful&width=1440&height=900&seq=puregold-la&orientation=landscape",
  },
  {
    name: "San Francisco",
    country: "California, USA",
    flag: "🇺🇸",
    image: "https://readdy.ai/api/search-image?query=San%20Francisco%20Golden%20Gate%20Bridge%20glowing%20entirely%20in%20deep%20rich%20molten%20gold%20amber%20bronze%20metallic%20light%20bay%20water%20reflecting%20pure%20gold%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning&width=1440&height=900&seq=puregold-sf&orientation=landscape",
  },
  {
    name: "Houston, Texas",
    country: "USA",
    flag: "🇺🇸",
    image: "https://readdy.ai/api/search-image?query=Houston%20Texas%20downtown%20skyline%20completely%20immersed%20in%20deep%20molten%20gold%20amber%20bronze%20metallic%20warm%20light%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning%20beautiful%20dramatic&width=1440&height=900&seq=puregold-houston&orientation=landscape",
  },
  {
    name: "London",
    country: "England, UK",
    flag: "🇬🇧",
    image: "https://readdy.ai/api/search-image?query=London%20Tower%20Bridge%20Thames%20River%20entirely%20bathed%20in%20deep%20rich%20molten%20gold%20amber%20bronze%20metallic%20light%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20warm%20atmosphere%20stunning%20beautiful%20dramatic&width=1440&height=900&seq=puregold-london&orientation=landscape",
  },
  {
    name: "Paris",
    country: "France",
    flag: "🇫🇷",
    image: "https://readdy.ai/api/search-image?query=Paris%20Eiffel%20Tower%20Seine%20River%20completely%20immersed%20in%20deep%20molten%20gold%20amber%20bronze%20metallic%20warm%20light%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning%20beautiful%20romantic%20dramatic&width=1440&height=900&seq=puregold-paris&orientation=landscape",
  },
  {
    name: "Sydney",
    country: "Australia",
    flag: "🇦🇺",
    image: "https://readdy.ai/api/search-image?query=Sydney%20Opera%20House%20Harbour%20Bridge%20entirely%20bathed%20in%20deep%20rich%20molten%20gold%20amber%20bronze%20metallic%20light%20harbor%20water%20reflecting%20pure%20gold%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning&width=1440&height=900&seq=puregold-sydney&orientation=landscape",
  },
  {
    name: "Dubai",
    country: "UAE",
    flag: "🇦🇪",
    image: "https://readdy.ai/api/search-image?query=Dubai%20Burj%20Khalifa%20skyline%20completely%20immersed%20in%20deep%20molten%20gold%20amber%20bronze%20metallic%20warm%20desert%20light%20luxury%20opulent%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning%20beautiful%20dramatic&width=1440&height=900&seq=puregold-dubai&orientation=landscape",
  },
  {
    name: "Tokyo",
    country: "Japan",
    flag: "🇯🇵",
    image: "https://readdy.ai/api/search-image?query=Tokyo%20Japan%20city%20skyline%20Mount%20Fuji%20entirely%20bathed%20in%20deep%20rich%20molten%20gold%20amber%20bronze%20metallic%20light%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20warm%20atmosphere%20stunning%20beautiful%20dramatic&width=1440&height=900&seq=puregold-tokyo&orientation=landscape",
  },
  {
    name: "Singapore",
    country: "Singapore",
    flag: "🇸🇬",
    image: "https://readdy.ai/api/search-image?query=Singapore%20Marina%20Bay%20Sands%20skyline%20completely%20immersed%20in%20deep%20molten%20gold%20amber%20bronze%20metallic%20warm%20light%20harbor%20reflecting%20pure%20gold%20luxury%20cinematic%20all%20gold%20tones%20no%20blue%20pure%20amber%20atmosphere%20stunning&width=1440&height=900&seq=puregold-singapore&orientation=landscape",
  },
];

const SLIDE_DURATION = 5000;

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState<number | null>(null);
  const [transitioning, setTransitioning] = useState(false);
  const [paused, setPaused] = useState(false);

  const goTo = useCallback(
    (index: number) => {
      if (transitioning) return;
      setTransitioning(true);
      setPrev(current);
      setCurrent(index);
      setTimeout(() => {
        setPrev(null);
        setTransitioning(false);
      }, 1000);
    },
    [current, transitioning]
  );

  const goNext = useCallback(() => {
    goTo((current + 1) % CITIES.length);
  }, [current, goTo]);

  const goPrev = useCallback(() => {
    goTo((current - 1 + CITIES.length) % CITIES.length);
  }, [current, goTo]);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(goNext, SLIDE_DURATION);
    return () => clearInterval(timer);
  }, [goNext, paused]);

  const city = CITIES[current];

  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "linear-gradient(135deg, #3D2000 0%, #7B4A00 30%, #B8860B 60%, #DAA520 100%)" }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {/* ── Slideshow Layers ── */}
      {CITIES.map((c, i) => (
        <div
          key={c.name}
          className="absolute inset-0"
          style={{
            opacity: i === current ? 1 : i === prev ? 0 : 0,
            zIndex: i === current ? 2 : i === prev ? 1 : 0,
            transition: "opacity 1s ease-in-out",
          }}
        >
          <img
            src={c.image}
            alt={c.name}
            className="w-full h-full object-cover object-center"
            loading={i === 0 ? "eager" : "lazy"}
          />
        </div>
      ))}

      {/* ── Gold Cinematic Overlays ── */}
      {/* Strong gold-amber tint over the whole image */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background: "linear-gradient(135deg, rgba(61,32,0,0.75) 0%, rgba(120,75,0,0.55) 40%, rgba(184,134,11,0.45) 70%, rgba(218,165,32,0.35) 100%)",
        }}
      />
      {/* Gold shimmer radial from center-top */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background: "radial-gradient(ellipse at 50% 0%, rgba(255,215,0,0.28) 0%, rgba(184,134,11,0.12) 50%, transparent 75%)",
        }}
      />
      {/* Left text-area dark amber gradient for readability */}
      <div
        className="absolute inset-0 z-10"
        style={{
          background: "linear-gradient(105deg, rgba(30,15,0,0.80) 0%, rgba(61,32,0,0.60) 40%, rgba(120,75,0,0.20) 70%, transparent 100%)",
        }}
      />
      {/* Bottom gold-to-dark fade */}
      <div
        className="absolute bottom-0 left-0 right-0 h-52 z-10"
        style={{
          background: "linear-gradient(to top, rgba(30,15,0,0.90) 0%, rgba(61,32,0,0.50) 50%, transparent 100%)",
        }}
      />
      {/* Gold shimmer pattern overlay */}
      <div
        className="absolute inset-0 z-10 opacity-10"
        style={{
          backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 40px, rgba(255,215,0,0.15) 40px, rgba(255,215,0,0.15) 80px)",
        }}
      />

      {/* ── City Label — bottom left ── */}
      <div className="absolute bottom-24 left-6 md:left-14 z-30 flex items-center gap-3">
        <span className="text-3xl drop-shadow-lg">{city.flag}</span>
        <div>
          <p
            className="font-extrabold text-xl leading-tight tracking-wide"
            style={{ color: "#F5D060", textShadow: "0 2px 12px rgba(0,0,0,0.7)" }}
          >
            {city.name}
          </p>
          <p className="text-xs font-medium" style={{ color: "rgba(245,208,96,0.65)" }}>
            {city.country}
          </p>
        </div>
      </div>

      {/* ── Slide Counter — bottom right ── */}
      <div
        className="absolute bottom-24 right-6 md:right-14 z-30 font-mono text-sm font-bold tracking-widest"
        style={{ color: "rgba(245,208,96,0.7)" }}
      >
        {String(current + 1).padStart(2, "0")}
        <span style={{ color: "rgba(245,208,96,0.3)" }}> / {String(CITIES.length).padStart(2, "0")}</span>
      </div>

      {/* ── Gold Progress Bar ── */}
      <div className="absolute bottom-0 left-0 right-0 z-30 h-1" style={{ background: "rgba(245,208,96,0.15)" }}>
        <div
          key={`prog-${current}`}
          className="h-full"
          style={{
            background: "linear-gradient(to right, #B8860B, #F5D060, #FFD700)",
            animation: `goldProgress ${SLIDE_DURATION}ms linear forwards`,
            boxShadow: "0 0 8px rgba(255,215,0,0.6)",
          }}
        />
      </div>

      {/* ── Dot Indicators ── */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-30 flex items-center gap-2">
        {CITIES.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            className="transition-all duration-400 rounded-full cursor-pointer"
            style={{
              width: i === current ? "28px" : "8px",
              height: "8px",
              background:
                i === current
                  ? "linear-gradient(to right, #B8860B, #FFD700)"
                  : "rgba(245,208,96,0.35)",
              boxShadow: i === current ? "0 0 8px rgba(255,215,0,0.7)" : "none",
            }}
          />
        ))}
      </div>

      {/* ── Arrow Controls ── */}
      <button
        onClick={goPrev}
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-30 w-11 h-11 md:w-13 md:h-13 flex items-center justify-center rounded-full cursor-pointer transition-all"
        style={{
          background: "rgba(245,208,96,0.15)",
          border: "1px solid rgba(245,208,96,0.45)",
          color: "#F5D060",
          backdropFilter: "blur(6px)",
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "rgba(245,208,96,0.35)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "rgba(245,208,96,0.15)";
        }}
      >
        <i className="ri-arrow-left-s-line text-2xl" />
      </button>
      <button
        onClick={goNext}
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-30 w-11 h-11 flex items-center justify-center rounded-full cursor-pointer transition-all"
        style={{
          background: "rgba(245,208,96,0.15)",
          border: "1px solid rgba(245,208,96,0.45)",
          color: "#F5D060",
          backdropFilter: "blur(6px)",
        }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "rgba(245,208,96,0.35)";
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.background = "rgba(245,208,96,0.15)";
        }}
      >
        <i className="ri-arrow-right-s-line text-2xl" />
      </button>

      {/* ── City Thumbnail Strip — right side ── */}
      <div className="absolute right-4 top-1/2 -translate-y-1/2 z-30 hidden xl:flex flex-col gap-2">
        {CITIES.map((c, i) => (
          <button
            key={c.name}
            onClick={() => goTo(i)}
            className="relative overflow-hidden cursor-pointer transition-all duration-300"
            style={{
              width: i === current ? "64px" : "48px",
              height: i === current ? "44px" : "32px",
              borderRadius: "6px",
              border: i === current ? "2px solid #FFD700" : "1px solid rgba(245,208,96,0.3)",
              boxShadow: i === current ? "0 0 12px rgba(255,215,0,0.6)" : "none",
              opacity: i === current ? 1 : 0.55,
            }}
          >
            <img src={c.image} alt={c.name} className="w-full h-full object-cover object-center" loading="lazy" />
            {i === current && (
              <div className="absolute inset-0" style={{ background: "rgba(255,215,0,0.2)" }} />
            )}
          </button>
        ))}
      </div>

      {/* ── Main Content ── */}
      <div className="relative z-20 w-full px-4 md:px-14 pt-24 pb-32 md:pt-28 md:pb-36">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">

          {/* Left — Text */}
          <div>
            {/* Badge */}
            <div
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest px-3 py-1.5 md:px-4 md:py-2 rounded-full mb-5 md:mb-7"
              style={{
                background: "rgba(255,215,0,0.15)",
                border: "1px solid rgba(255,215,0,0.5)",
                color: "#FFD700",
              }}
            >
              <i className="ri-flag-line" />
              🇺🇸 USA Local Warehouse · Global Factory Network
            </div>

            {/* Headline */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 md:mb-5" style={{ fontFamily: "'Times New Roman', Times, serif" }}>
              <span style={{ color: "#FFD700", textShadow: "0 0 40px rgba(255,215,0,0.5)" }}>
                Fast Shipping
              </span>
              <br />
              <span className="text-white">from USA Local</span>
              <br />
              <span className="text-white">Verified Factories</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold leading-relaxed mb-4 md:mb-5 max-w-2xl" style={{ color: "rgba(255,255,255,0.95)", fontFamily: "'Times New Roman', Times, serif" }}>
              Welcome to place bulk orders from our verified <strong style={{ color: "#FFD700" }}>million global factories</strong>. We together make sure <strong style={{ color: "#FFD700" }}>high quality products</strong> and <strong style={{ color: "#FFD700" }}>best competitive price</strong> — and make sure all container buyers' big <strong style={{ color: "#FFD700" }}>fund safety</strong> is fully protected, keeping every buyer guaranteed to receive <strong style={{ color: "#FFD700" }}>high quality products</strong>.
            </p>

            {/* Promise pills */}
            <div className="flex flex-wrap gap-2 mb-6 md:mb-8">
              {[
                { icon: "ri-truck-line", text: "Fast USA Shipping" },
                { icon: "ri-shield-check-line", text: "Buyer Fund Safety" },
                { icon: "ri-medal-line", text: "High Quality Guaranteed" },
                { icon: "ri-price-tag-3-line", text: "Best Competitive Price" },
              ].map((p) => (
                <span
                  key={p.text}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap"
                  style={{ background: "rgba(255,215,0,0.13)", border: "1px solid rgba(255,215,0,0.35)", color: "#FFD700" }}
                >
                  <i className={p.icon} />
                  {p.text}
                </span>
              ))}
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-6 md:gap-8 mb-8 md:mb-10">
              {[
                { value: "1M+", label: "Global Factories" },
                { value: "120+", label: "Countries" },
                { value: "100%", label: "Buyer Protected" },
              ].map((stat) => (
                <div key={stat.label}>
                  <div
                    className="text-2xl md:text-3xl font-extrabold"
                    style={{ color: "#FFD700", textShadow: "0 0 20px rgba(255,215,0,0.4)" }}
                  >
                    {stat.value}
                  </div>
                  <div className="text-xs mt-0.5" style={{ color: "rgba(255,255,255,0.55)" }}>
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4">
              <Link
                to="/usa-shop"
                className="px-6 md:px-8 py-3 md:py-3.5 font-bold rounded-full transition-all cursor-pointer whitespace-nowrap text-sm md:text-base hover:scale-105 text-center"
                style={{
                  background: "linear-gradient(135deg, #B8860B 0%, #FFD700 50%, #DAA520 100%)",
                  color: "#1a0f00",
                  boxShadow: "0 4px 24px rgba(255,215,0,0.5)",
                }}
              >
                <i className="ri-store-2-line mr-2" />Shop USA Warehouse
              </Link>
              <Link
                to="/wholesale"
                className="px-6 md:px-8 py-3 md:py-3.5 font-bold rounded-full transition-all cursor-pointer whitespace-nowrap text-sm md:text-base hover:scale-105 text-center"
                style={{
                  background: "rgba(255,215,0,0.12)",
                  border: "1.5px solid rgba(255,215,0,0.6)",
                  color: "#FFD700",
                }}
              >
                <i className="ri-ship-line mr-2" />Place Bulk Order
              </Link>
            </div>
          </div>

          {/* Right — Floating Cards */}
          <div className="hidden lg:flex flex-col gap-4 items-end pr-16">

            {/* Product Card */}
            <div
              className="rounded-2xl p-4 w-72"
              style={{
                background: "rgba(255,248,220,0.96)",
                border: "1px solid rgba(255,215,0,0.4)",
                boxShadow: "0 8px 32px rgba(61,32,0,0.35), 0 0 0 1px rgba(255,215,0,0.15)",
              }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=wireless%20earbuds%20white%20product%20clean%20background&width=48&height=48&seq=hcard1&orientation=squarish"
                    alt="Product"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold" style={{ color: "#3D2000" }}>Wireless Earbuds Pro</div>
                  <div className="text-xs" style={{ color: "#8B6914" }}>TechVision Factory</div>
                </div>
                <div className="ml-auto">
                  <span className="font-bold text-sm" style={{ color: "#B8860B" }}>$49.99</span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className="flex items-center gap-1 text-xs px-2 py-1 rounded-full" style={{ background: "rgba(184,134,11,0.12)", color: "#7B5200" }}>
                  <i className="ri-shield-check-line" /> Verified
                </span>
                <span className="text-xs" style={{ color: "#8B6914" }}>⭐ 4.8 (2.3K)</span>
                <span
                  className="ml-auto text-xs font-bold px-2 py-0.5 rounded-full"
                  style={{ background: "rgba(255,215,0,0.2)", color: "#B8860B" }}
                >
                  12% comm.
                </span>
              </div>
            </div>

            {/* Live Buyer Activity Card */}
            <div
              className="rounded-2xl p-4 w-80"
              style={{
                background: "rgba(255,248,220,0.96)",
                border: "1px solid rgba(255,215,0,0.4)",
                boxShadow: "0 8px 32px rgba(61,32,0,0.35)",
              }}
            >
              <div className="flex items-center gap-2 mb-3">
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-lg"
                  style={{ background: "rgba(255,215,0,0.2)" }}
                >
                  <i className="ri-global-line" style={{ color: "#B8860B" }} />
                </div>
                <p className="text-sm font-bold" style={{ color: "#3D2000" }}>Live Buyer Activity</p>
                <span className="ml-auto flex items-center gap-1 text-xs font-semibold" style={{ color: "#7B5200" }}>
                  <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: "#B8860B" }} />
                  Live
                </span>
              </div>
              <div className="space-y-2.5">
                {[
                  { city: "New York", flag: "🇺🇸", action: "Placed bulk order", time: "2m ago" },
                  { city: "London", flag: "🇬🇧", action: "Requested a quote", time: "5m ago" },
                  { city: "Sydney", flag: "🇦🇺", action: "Submitted requirement", time: "8m ago" },
                  { city: "Paris", flag: "🇫🇷", action: "Viewed factory catalog", time: "11m ago" },
                ].map((b) => (
                  <div key={b.city} className="flex items-center gap-2 text-xs" style={{ color: "#6B4500" }}>
                    <span className="text-base">{b.flag}</span>
                    <span className="font-semibold" style={{ color: "#3D2000" }}>{b.city}</span>
                    <span style={{ color: "#8B6914" }}>— {b.action}</span>
                    <span className="ml-auto whitespace-nowrap" style={{ color: "#A07830" }}>{b.time}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Influencer Earnings Card */}
            <div
              className="rounded-2xl p-4 w-72"
              style={{
                background: "rgba(255,248,220,0.96)",
                border: "1px solid rgba(255,215,0,0.4)",
                boxShadow: "0 8px 32px rgba(61,32,0,0.35)",
              }}
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=young%20woman%20influencer%20portrait%20smiling%20warm%20light&width=48&height=48&seq=hcard2&orientation=squarish"
                    alt="Influencer"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold" style={{ color: "#3D2000" }}>Jessica M.</span>
                    <i className="ri-tiktok-line text-xs" style={{ color: "#8B6914" }} />
                    <span className="text-xs px-1.5 py-0.5 rounded-full font-medium" style={{ background: "rgba(255,215,0,0.2)", color: "#B8860B" }}>2.3M</span>
                  </div>
                  <div className="text-xs mt-0.5" style={{ color: "#6B4500" }}>Earned <strong style={{ color: "#B8860B" }}>$12,430</strong> this month</div>
                </div>
                <Link
                  to="/influencer"
                  className="text-xs px-3 py-1.5 rounded-full font-bold whitespace-nowrap cursor-pointer hover:scale-105 transition-transform"
                  style={{
                    background: "linear-gradient(135deg, #B8860B, #FFD700)",
                    color: "#1a0f00",
                  }}
                >
                  Join
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── CSS Keyframes ── */}
      <style>{`
        @keyframes goldProgress {
          from { width: 0%; }
          to   { width: 100%; }
        }
      `}</style>
    </section>
  );
}
